<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import TokenTotalBar from './TokenTotalBar.vue'
import XrpLedgerCard from './XrpLedgerCard.vue'
import TokenWalletEmpty from './TokenWalletEmpty.vue'
import ActivityList from '../../transactions/components/ActivityList.vue'
import type { Transaction } from '../../transactions/types/transactionTypes'

interface Props {
  /** Pre-formatted token total, e.g. `"98,722,222"`. */
  totalTokens?: string
  /** Public XRPL explorer URL for this investor's account. */
  explorerUrl?: string
  transactions?: Transaction[]
  loading?: boolean
  loadingMore?: boolean
  hasMore?: boolean
  /** Route for the activity card's "See All" link. */
  seeAllTo?: string
  /** No wallet / no holdings — swaps the whole tab for the empty state. */
  isEmpty?: boolean
}

withDefaults(defineProps<Props>(), {
  totalTokens: '',
  explorerUrl: '',
  transactions: () => [],
  loading: false,
  loadingMore: false,
  hasMore: false,
  seeAllTo: '',
  isEmpty: false,
})

const emit = defineEmits<{
  (e: 'view-details', tx: Transaction): void
  (e: 'load-more'): void
}>()
</script>

<template>
  <Box direction="col" gap="6" class="twt">
    <TokenWalletEmpty v-if="isEmpty" />

    <template v-else>
      <TokenTotalBar :total="totalTokens" :loading="loading" />
      <XrpLedgerCard :explorer-url="explorerUrl" />

      <ActivityList
        :transactions="transactions"
        :loading="loading"
        :loading-more="loadingMore"
        :has-more="hasMore"
        :see-all-to="seeAllTo"
        empty-title="No token activity yet"
        empty-description="Tokens you receive from property investments will show up here."
        empty-cta-label=""
        @load-more="emit('load-more')"
        @view-details="(tx) => emit('view-details', tx)"
      />
    </template>
  </Box>
</template>

<style scoped>
.twt {
  width: 100%;
}
</style>
